import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const SiteCard = styled.div`
    width: 100%;
    background-color: ${colors.light};
    padding: 30px;
    border-radius: 5px;
    &.middle {
        margin: 0 30px;
    }
    @media screen and (max-width: ${ScreenSize.tabletPlus}px) {
        width: 100%;
        margin-bottom: 32px;
        &.middle {
            margin: 30px 0;
        }
    }
`;

export const SiteCardTitle = styled.div`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase; 
    color: ${colors.black};
    > span {
        color: ${colors.red};
    }
    margin-bottom: 10px;
`;

export const SiteCardSubTitle = styled.div`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 15px;
    text-transform: capitalize; 
    color: ${colors.black};
    > span {
        font-weight: 600;
    }
    @media screen and (max-width: ${ScreenSize.tabletPlus}px) {
        width: 100%;
        &.middle {
            margin: 30px 0;
        }
    }
`;

export const SiteThumbnail = styled.div`
    width: 100%;
    justify-content: center;
    > img {
        width: 100%;
    }
`;

export const DescriptionTitle = styled.h1`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-weight: 600;
`;

export const DescriptionRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    font-size: 14px;
    > .icon {
        color: ${colors.red};
        min-width: 14px;
        margin-right: 5px;
    }
`;

export const DescriptionDetail = styled.div`
    font-size: 14px;
    color: ${({ isActive }) => (isActive ? colors.black : colors.lightGrey8)};
`;

export const DescriptionDivisor = styled.div`
    margin: 30px -20px;
    border-top: 1px solid ${colors.lightGrey41};
`;
